export function formatPrice(price = 0, withCurrency = true) {
  const number = Number.parseInt(String(price).replace(/\s/g, '').replace(',', '.'), 10);
  const priceValue = isNaN(number) ? 0 : number;
  return new Intl.NumberFormat('ru-RU').format(String(priceValue)) + (withCurrency ? ' ₽' : '');
}
